import '../assets/Styles/LoginCSS/Login.css';
import React from 'react';
import LoginAuto from '../components/Login/loginauto';


function LoginAutoPage() {

    return (
        <LoginAuto />
    );
}

export default LoginAutoPage;
